import { AppContext, DateTimeFormatter } from '@nile/components';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import { TextStyle } from '@superops/ui-design-system';

function DateTimeCell(props) {
  const { cell } = props;
  const type = cell?.column?.dataType;
  return cell.value ? (
    <div className="w100">
      <div className="ellipsis" title={cell.value}>
        <DateTimeFormatter type={type || 'dateTime'} date={cell.value} />
      </div>
    </div>
  ) : (
    <TextStyle disabled>NA</TextStyle>
  );
}

export default DateTimeCell;
